import { Component, useEffect } from "react";

import {
    IPromiseIntervalHandle,
    setPromiseInterval,
} from "@formant/core/common/setPromiseInterval";
import { Timeout } from "@formant/core/model/Timeout";

interface IUseTimerOptions {
    enabled?: boolean;
    interval: number;
    wait?: boolean;
}

const quantizeTo = (tick: number = 0): number => {
    const now = new Date();
    const slide = tick - now.getMilliseconds();
    return slide;
};

export function useTimer(callback: () => void, options: IUseTimerOptions) {
    const { enabled = true, interval, wait = false } = options;

    useEffect(() => {
        if (!enabled) {
            return;
        }

        if (wait) {
            const { stop } = setPromiseInterval({
                func: async () => callback(),
                delay: interval,
                immediate: false,
            });

            return () => stop();
        } else {
            const timeout = setInterval(callback, interval);
            const stop = () => {
                clearInterval(timeout);
            };

            return () => stop();
        }
    }, [callback, interval, wait, enabled]);
}

export interface ITimerProps {
    onTick: () => void;
    interval: number;
    wait?: boolean;
    quantizeStart?: number;
    delay?: number;
}

export class Timer extends Component<ITimerProps> {
    private interval?: Timeout;
    private promiseInterval?: IPromiseIntervalHandle;

    public componentDidMount() {
        const { onTick: callback, interval, wait, quantizeStart } = this.props;

        if (wait) {
            this.promiseInterval = setPromiseInterval({
                func: async () => callback(),
                delay: interval,
                immediate: false,
            });
            return;
        }
        if (quantizeStart) {
            let offset: number = 0;
            if (this.props.delay) {
                offset = quantizeStart + this.props.delay;
            } else {
                offset = quantizeStart;
            }
            setTimeout(() => {
                this.interval = setInterval(callback, interval);
            }, quantizeTo(offset));
        } else {
            this.interval = setInterval(callback, interval);
        }
    }

    public async componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        if (this.promiseInterval) {
            await this.promiseInterval.stop();
        }
    }

    public render() {
        return false;
    }
}
